<div class="flex flex-col w-full h-full flex-1 min-h-0">
  @if (isLoading()) {
  <div class="animate-pulse flex flex-col gap-3 p-2">
    <div class="h-4 bg-secondary-border rounded w-1/3"></div>
    <div class="h-[500px] bg-secondary-border rounded w-full"></div>
  </div>
  } @else if (isRelationsLoading()) {
  <div class="animate-pulse flex flex-col gap-3 p-2">
    <div class="h-4 bg-secondary-border rounded w-1/4 mb-2"></div>
    <div class="h-[500px] bg-secondary-border rounded w-full"></div>
    <div class="text-secondary-text text-sm italic mt-2"
         i18n="@@dataViewer.loadingRelations">Loading relations config...</div>
  </div>
  } @else {

  @if (data().length === 0) {
  <div class="mb-4 bg-info/10 border border-info/20 text-info px-4 py-3 rounded-md flex items-center gap-2 shadow-sm">
    <i class="fas fa-info-circle text-lg"></i>
    <span class="font-medium">{{ localTexts.noData }}</span>
  </div>
  }

  @if (recordIds && recordIds.length > 0) {
  <div class="mb-4 bg-info/10 border border-info/20 text-info px-4 py-3 rounded-md flex items-center gap-2 shadow-sm">
    <i class="fas fa-info-circle text-lg"></i>
    <span class="font-medium">{{ localTexts.specificRecordsInfo }} ({{ recordIds.length }})</span>
  </div>
  }

  <!-- Spreadsheet Controls -->
  <div
       class="border border-secondary-border rounded-md shadow-sm p-2  mb-3 flex flex-wrap items-center gap-2 justify-start">
    <button nz-button
            nzType="default"
            nzSize="small"
            (click)="spreadsheetViewer.autoSizeColumns()"
            class="flex items-center gap-1.5 !rounded-md text-secondary-text hover:text-primary transition-colors">
      <i class="fas fa-arrows-left-right"></i>
      <span class="ml-1"
            i18n="@@dataViewer.autoSize">Auto Size</span>
    </button>
    <button nz-button
            nzType="default"
            nzSize="small"
            (click)="toggleIdFields()"
            class="flex items-center gap-1.5 !rounded-md transition-colors"
            [ngClass]="isIdVisible() ? 'text-primary border-primary bg-primary/5' : 'text-secondary-text'">
      <i class="fas"
         [ngClass]="isIdVisible() ? 'fa-eye' : 'fa-eye-slash'"></i>
      <span class="ml-1"
            i18n="@@dataViewer.id">ID</span>
    </button>
    <button nz-button
            nzType="default"
            nzSize="small"
            (click)="toggleAuditFields()"
            class="flex items-center gap-1.5 !rounded-md transition-colors"
            [ngClass]="isAuditVisible() ? 'text-primary border-primary bg-primary/5' : 'text-secondary-text'">
      <i class="fas"
         [ngClass]="isAuditVisible() ? 'fa-eye' : 'fa-eye-slash'"></i>
      <span class="ml-1"
            i18n="@@dataViewer.audit">Audit</span>
    </button>
  </div>

  <div
       class="mb-4 w-full h-[50vh] min-h-[400px] max-h-[800px] flex-shrink-0 flex flex-col overflow-hidden rounded-lg shadow-sm border border-secondary-border relative">

    @if (pendingChanges().size > 0) {
    <div class="flex flex-col animate-fade-in">
      <div class="border border-warning/30 text-warning-text px-3 py-2 rounded-md flex items-center justify-between shadow-sm"
           style="position: absolute; z-index: 11; width: 100%; background-color: #fff5d6;">
        <div class="flex items-center gap-3">
          <i class="fas fa-exclamation-triangle text-warning text-xl"></i>
          <span class="font-medium">
            <span class="font-bold">{{ pendingChanges().size }}</span> {{ localTexts.unsavedChanges }}
          </span>
        </div>
        <div class="flex items-center gap-2">
          <button nz-button
                  nzType="default"
                  nzSize="small"
                  nz-popconfirm
                  [nzPopconfirmTitle]="localTexts.discardConfirm"
                  (nzOnConfirm)="discardChanges()"
                  class="border-secondary-border text-secondary-text hover:text-danger hover:border-danger flex items-center gap-2 shadow-sm focus:outline-none">
            <i class="fas fa-undo"></i>
            <span>{{ localTexts.discardChangesBtn }}</span>
          </button>
          <button nz-button
                  nzType="primary"
                  nzSize="small"
                  [nzLoading]="isSaving()"
                  (click)="saveChanges()"
                  class="bg-warning text-white border-none hover:bg-warning/80 flex items-center gap-2 font-bold shadow-sm focus:outline-none">
            @if (!isSaving()) { <i class="fas fa-save"></i> }
            <span>{{ localTexts.saveChangesBtn }}</span>
          </button>
        </div>
      </div>


    </div>
    }

    <rapider-spreadsheet-viewer class="flex-1 flex flex-col min-h-0 w-full h-full"
                                [data]="data()"
                                [name]="projectModelName"
                                [fields]="spreadsheetFields()"
                                [darkMode]="isAppInDarkMode()"
                                (cellUpdated)="handleCellUpdate($event)"
                                (rowSelected)="handleRowSelected($event)">
    </rapider-spreadsheet-viewer>
  </div>

  @if (pendingChanges().size > 0) {
  <!-- Legends: Row and Cell Indicators -->
  <div
       class="flex flex-wrap gap-4 px-2 py-1 text-[12px] font-medium text-secondary-text border border-secondary-border rounded-md shadow-sm">
    <div class="flex items-center gap-2"
         title="A completely new row that is ready to be saved">
      <div class="w-3 h-3 rounded-sm border border-[#86EFAC]"
           style="background-color: #DCFCE7;"></div>
      <span>New Row</span>
    </div>
    <div class="flex items-center gap-2"
         title="An existing row that contains unsaved changes">
      <div class="w-3 h-3 rounded-sm border border-[#FDE047]"
           style="background-color: #FEF9C3;"></div>
      <span>Modified Row</span>
    </div>
    <div class="flex items-center gap-2"
         title="A specific cell that has been manually modified">
      <div class="w-3 h-3 rounded-sm border border-[#FDE047]"
           style="background-color: #FDE047;"></div>
      <span>Modified Cell</span>
    </div>
    <div class="flex items-center gap-2"
         title="A cell that has an invalid data format or is missing a required value">
      <div class="w-3 h-3 rounded-sm border border-[#FCA5A5]"
           style="background-color: #FECACA;"></div>
      <span>Invalid / Missing Required</span>
    </div>
    <div class="flex items-center gap-2"
         title="A read-only or auto-generated system cell">
      <div class="w-3 h-3 rounded-sm border border-[#D1D5DB]"
           style="background-color: #F3F4F6;"></div>
      <span>Read-Only / Auto Generated</span>
    </div>
  </div>
  }

  @if ((!recordIds || recordIds.length === 0) && !!displayPagination) {
  <div class="mb-6 flex justify-end w-full border-t border-secondary-border pt-3 shrink-0">
    <nz-pagination [nzPageIndex]="currentPage()"
                   [nzTotal]="totalItems()"
                   [nzPageSize]="pageSize()"
                   (nzPageIndexChange)="onPageChange($event)">
    </nz-pagination>
  </div>
  }

  @if (selectedRecord(); as rec) {
  <div *ngIf="rec"
       class="mb-4 mt-6 w-full shrink-0">
    <rapider-data-card [projectModelName]="projectModelName"
                       [data]="rec"
                       [diffClassMap]="diffClassMap()"></rapider-data-card>
  </div>

  @if (model()?.relations; as relations) {
  <div class="flex flex-col gap-4 bg-alt-bold-background border border-primary-border rounded-lg p-4 shrink-0">
    @for (rel of relations; track rel.name; let isFirst = $first) {
    @if (rec[rel.name] !== undefined && rec[rel.name] !== null) {
    @if (!isFirst) {
    <nz-divider class="my-2 border-secondary-border"></nz-divider>
    }
    <div class="flex flex-col gap-2">
      <div class="flex items-center gap-2">
        <i class="fas fa-link text-info"></i>
        <span class="font-bold text-primary-text">{{ getTargetModelTitle(rel.targetModel?.title || rel.targetModel?.name
          || rel.name, cachedModels()) }}</span>
        <nz-tag class="!m-0 bg-info/10 text-info border-info/20">{{ rel.name }}</nz-tag>
      </div>

      <div class="bg-component-inner rounded-lg border border-secondary-border p-2 shadow-sm overflow-hidden">
        @if (getRelationDisplayType(rel.type, rec[rel.name]) === 'grid') {
        <rapider-list-grid [config]="getGridConfigForModel(rel.targetModel?.name || rel.name, cachedModels(), normalizeDataAsArray(rec[rel.name]))"
                           [data]="normalizeDataAsArray(rec[rel.name])">
        </rapider-list-grid>
        } @else {
        <rapider-json-viewer [data]="rec[rel.name]"
                             [maxLineToDisplay]="10"
                             class="w-full">
        </rapider-json-viewer>
        }
      </div>
    </div>
    } @else {
    <div class="flex flex-col gap-2">
      <div class="flex items-center gap-2">
        <i class="fas fa-link text-info"></i>
        <span class="font-bold text-primary-text">{{ getTargetModelTitle(rel.targetModel?.title || rel.targetModel?.name
          || rel.name, cachedModels()) }}</span>
        <nz-tag class="!m-0 bg-info/10 text-info border-info/20">{{ rel.name }}</nz-tag>
      </div>
      <div class="text-secondary-text text-sm italic p-2 flex items-center gap-2">
        <i class="fas fa-info-circle"></i> {{ localTexts.noData }}
      </div>
    </div>
    }
    }
  </div>
  }
  }
  }
</div>